const SUCCESS = 100
const FAILURE = 0
const PARAM_IS_NULL = 11
const KEY_PARAMETER_LOSE = 13
const NO_PERMISSION = 208
const NOT_FOUND = 404
const HTTP_EXCEPTION = 500
const HTTP_CONNECT_TOO_MUCH = 503
const AUTH_RELOGIN = 510
const CONTROLLER_RUNTIME_EXCEPTION = 530
const HTTP_HIGH_FREQUENCY = 598
const NETWORK_ERROR = 1000
export default {
  SUCCESS,
  FAILURE,
  PARAM_IS_NULL,
  KEY_PARAMETER_LOSE,
  NO_PERMISSION,
  NOT_FOUND,
  HTTP_EXCEPTION,
  HTTP_CONNECT_TOO_MUCH,
  AUTH_RELOGIN,
  CONTROLLER_RUNTIME_EXCEPTION,
  HTTP_HIGH_FREQUENCY,
  NETWORK_ERROR
}
